import React from "react";
import useStyles from "../styles";
import {Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel, Radio, RadioGroup} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Loading from "../../../components/Shared/Loading";
import TextField from "@material-ui/core/TextField";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import Pdf from "medis/src/assets/pdf/Договір публічної оферти_МеДіС.pdf";
import {useDispatch, useSelector} from "react-redux";
import uaLocale from 'date-fns/locale/uk';
import DateFnsUtils from "@date-io/date-fns";
import {setClient, setListOfPatients, START_PHONE_SEND} from "@cabinet-packages/redux";
import {checkPatient, editPatientData, registerExisting} from "@cabinet-packages/api/api";
import {AccessKey} from "@cabinet-packages/helpers";

const EighthStage = ({isDoctor, handleValueActivePatient, handleValueActivePatientFormControl, handleCheckboxState,
                         isChangedStateSignUp, phone, uuid}) => {
    const cl = useStyles();
    const dispatch = useDispatch();
    const {listOfPatients} = useSelector(state => state.patients); //here
    const {takeId} = useSelector(state => state.assaysCatalog);
    const [valueActivePatient, setValueActivePatient] = handleValueActivePatient;
    const [valueActivePatientFormControl, setValueActivePatientFormControl] = handleValueActivePatientFormControl;
    const [checkboxState, setCheckboxState] = handleCheckboxState;

    const handleChangeActivePatient = (event) => {
        setValueActivePatientFormControl(+event.target.value);
        const foundPatient = listOfPatients.find(patient => +patient.id === +event.target.value);
        setValueActivePatient({...foundPatient, birthday: new Date(foundPatient.birthday)});
    };

    const updateStateActivePatient = (field, value) => {
        setValueActivePatient(prev => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleChange = (event) => {
        setCheckboxState({ ...checkboxState, [event.target.name]: event.target.checked });
    };

    const handleSignIn = async () => {
        const patients = await checkPatient('CHECK', uuid, null, phone, AccessKey.get());
        dispatch(setListOfPatients(false, isDoctor, patients));

        await registerExisting(
                valueActivePatient.id,
                listOfPatients.map(patient => patient.id).filter(id => +id !== +valueActivePatient.id),
                phone.replace(/[[()\s]/g, ''),
                checkboxState.checkedA,
                checkboxState.checkedB,
                false,null, uuid);

        const birthday = typeof valueActivePatient.birthday === 'string'
            ? valueActivePatient.birthday
            : !isDoctor && new Date(valueActivePatient.birthday.toString()).toLocaleDateString().split('.').reverse().join('-');

        await editPatientData(valueActivePatient.lastname,
                valueActivePatient.firstname,
                valueActivePatient.fathername,
                birthday,
                valueActivePatient.sex,
                valueActivePatient.id,
                uuid,
            );

        dispatch(setClient({...valueActivePatient, birthday}));

        dispatch({
            type: START_PHONE_SEND,
            payload: {
                stage: 6,
            },
        });
    };

    return (listOfPatients ? <div className={cl.createClientWrapper}>
            <div className={cl.selectActivePatientWrapper}>
                <div className={cl.selectActivePatient}>
                    {<FormControl component="div">
                        <FormLabel component="legend" className={cl.selectActivePatientHeader}>
                            {isDoctor
                                ? 'Вибір даних лікаря'
                                : 'Вибір головного пацієнта особистого кабінету:'}
                        </FormLabel>
                        <RadioGroup
                            aria-label="activePatient"
                            name="activePatient1"
                            onChange={handleChangeActivePatient}
                            value={valueActivePatientFormControl}
                        >
                            {listOfPatients.map(patient => (
                                <FormControlLabel
                                    key={patient.id}
                                    value={patient.id}
                                    control={<Radio color={"primary"}/>}
                                    label={`${patient.lastname} ${patient.firstname} ${patient.fathername}`}
                                />))
                            }
                        </RadioGroup>
                    </FormControl>}
                </div>
            </div>
            {valueActivePatient && <div className={cl.bodyContainer}>
                <TextField
                    value={valueActivePatient.lastname}
                    onChange={(event) => updateStateActivePatient('lastname', event.target.value)}
                    label="Прізвище*"
                />
                <TextField
                    value={valueActivePatient.firstname}
                    onChange={(event) => updateStateActivePatient('firstname', event.target.value)}
                    label="Ім'я*"
                />
                <TextField
                    value={valueActivePatient.fathername}
                    onChange={(event) => updateStateActivePatient('fathername', event.target.value)}
                    label="По-батькові*"
                />
                <div className={cl.birthdayContainer}>
                    <p style={{color: 'rgba(0, 0, 0, 0.54)'}}>Дата народження*</p>
                    {!isDoctor && <MuiPickersUtilsProvider utils={DateFnsUtils} locale={uaLocale}>
                        <KeyboardDatePicker
                            value={valueActivePatient.birthday}
                            onChange={(value) => updateStateActivePatient('birthday', value)}
                            invalidDateMessage="Неправильний формат дати."
                            maxDateMessage="Дата народження не може бути в майбутньому."
                            maxDate={new Date(new Date().setFullYear(new Date().getFullYear() - 18))}
                            format="yyyy-MM-dd"
                            disableFuture
                            cancelLabel="Назад"
                            okLabel="Ок"
                            openTo="year"
                        />
                    </MuiPickersUtilsProvider>}
                </div>
                <FormControl component="fieldset">
                    <FormLabel component="legend">Стать*</FormLabel>
                    <RadioGroup
                        aria-label="gender"
                        value={valueActivePatient.sex}
                        onChange={(event) => updateStateActivePatient('sex', event.target.value)}
                        className={cl.genderGroup}>
                        <FormControlLabel
                            value="F"
                            control={<Radio color="primary"/>}
                            label="Жіноча"
                        />
                        <FormControlLabel
                            value="M"
                            control={<Radio color="primary"/>}
                            label="Чоловіча"
                        />
                    </RadioGroup>
                </FormControl>
                <p className={cl.formAnnotation}>(*) Поля позначені зірочкою обов'язкові для
                    заповнення.</p>
            </div>}
            <FormGroup className={cl.formCheckboxes}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={checkboxState.checkedA}
                            onChange={handleChange}
                            name="checkedA"
                            color="primary"
                        />
                    }
                    label={<p>
                        Я погоджуюсь на використання <a href={takeId === 14 ? Pdf : undefined} target="_blank">
                        персональних даних.
                    </a>
                    </p>
                    }
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={checkboxState.checkedB}
                            onChange={handleChange}
                            name="checkedB"
                            color="primary"
                        />
                    }
                    label="Я погоджуюсь на створення персонального кабінету."
                />
            </FormGroup>
            <div className={cl.actionContainer}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSignIn}
                    className={cl.actionContainerButton}
                    disabled={isChangedStateSignUp || !checkboxState.checkedA || !checkboxState.checkedB}
                >
                    Підтвердити свої дані
                </Button>
            </div>
        </div>
        : <Loading />)
}

export default EighthStage;
